export default __webpack_public_path__ + "static/media/74.29e3105d.png";